import { tsInitVue } from './js-utils'
import CandidatesImportManager from '../js/vue-components/candidates-import-manager.vue'

document.addEventListener('DOMContentLoaded', function () {
  const importManagerEL = document.querySelector('body.candidates-import-batches.candidate-import div[data-is="CandidatesImportManager"]')
  if (importManagerEL instanceof HTMLElement) {
    window.candidatesImportManager = tsInitVue(CandidatesImportManager, importManagerEL, {
      listUrl: importManagerEL.dataset.listUrl,
      importUrl: importManagerEL.dataset.importUrl,
      allowEvents: importManagerEL.dataset.allowEvents == 'true',
      returnToTitle: importManagerEL.dataset.returnToTitle,
      returnToUrl: importManagerEL.dataset.returnToUrl
    })
  }
})
